import { useIntParam, useNavigationContext } from 'hooks';
import { speakingSessionStore } from 'store';

export const useSpeakingSessionDetails = () => {
  const speakingSessionId = useIntParam('sessionId');
  const { locationId } = useNavigationContext();

  const {
    data: speakingSession,
    isLoading,
    isError,
    error,
  } = speakingSessionStore.service.speakingSessionApi.useGetSpeakingSessionDetailsQuery({
    speakingSessionId,
    locationId,
  });

  const isNotFound = isError && 'status' in error && error.status === 404;

  return { speakingSession, isLoading, speakingSessionId, isNotFound };
};
